const _excluded = ["locale"];function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var n = Object.getOwnPropertySymbols(e);for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (-1 !== e.indexOf(n)) continue;t[n] = r[n];}return t;}import PropTypes from 'prop-types';
import React from 'react';
import { useAtomValue } from 'jotai';
import { localeAtom } from "../../V2/atoms/translationsAtoms";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { availableLanguages } from "../../../shared/language";
import { loadIcons } from "./library";

loadIcons();

const Icon = (_ref) => {let { locale: propLocale = '' } = _ref,ownProps = _objectWithoutProperties(_ref, _excluded);
  const atomLocale = useAtomValue(localeAtom);
  const locale = propLocale || atomLocale;
  const languageData = availableLanguages.find((l) => l.key === locale);
  const flip = languageData && languageData.rtl ? 'horizontal' : null;

  return /*#__PURE__*/React.createElement(FontAwesomeIcon, _extends({}, ownProps, { flip: flip }));
};





export default Icon;